'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_WebSockets$Closed$() {
}
export { $c_Lpresto_WebSockets$Closed$ as $c_Lpresto_WebSockets$Closed$ };
$p = $c_Lpresto_WebSockets$Closed$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_WebSockets$Closed$;
/** @constructor */
function $h_Lpresto_WebSockets$Closed$() {
}
export { $h_Lpresto_WebSockets$Closed$ as $h_Lpresto_WebSockets$Closed$ };
$h_Lpresto_WebSockets$Closed$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 2021313932;
});
$p.l = (function() {
  return "Closed";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Closed";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_WebSockets$Closed$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_WebSockets$Closed$, "presto.WebSockets$Closed$", ({
  Vh: 1,
  d8: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_WebSockets$Closed$ as $d_Lpresto_WebSockets$Closed$ };
var $n_Lpresto_WebSockets$Closed$;
function $m_Lpresto_WebSockets$Closed$() {
  if ((!$n_Lpresto_WebSockets$Closed$)) {
    $n_Lpresto_WebSockets$Closed$ = new $c_Lpresto_WebSockets$Closed$();
  }
  return $n_Lpresto_WebSockets$Closed$;
}
export { $m_Lpresto_WebSockets$Closed$ as $m_Lpresto_WebSockets$Closed$ };
//# sourceMappingURL=presto.-Web-Sockets$-Closed$.js.map
